import resolveConfig from 'tailwindcss/resolveConfig';

import { Config } from 'tailwindcss/types/config';

import tailwindConfig from '../tailwind/themes';

export const tailwindColors = resolveConfig(tailwindConfig as unknown as Config).theme.colors;

export const tailwindBreakpoints = resolveConfig(tailwindConfig as unknown as Config).theme.screens;
